<ng-container *ngFor="let suggestion of message.suggestions; first as isFirst">
  <button
    class="me-2 mb-2"
    [suggestion]="suggestion"
    [requestFocus]="isFirst"
    data-testid="suggestion-button"
  ></button>
</ng-container>
